import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminInvoiceSettingsResponse {
  @jsonMember(Boolean)
  public readonly isConnectedWithKsef!: boolean;

  @jsonMember(Boolean)
  public readonly sendToKsef!: boolean;

  @jsonMember(String)
  public readonly seller!: string;

  @jsonMember(String)
  public readonly temporaryInvoiceBankName!: string;

  @jsonMember(String)
  public readonly temporaryInvoiceAccount!: string;
}
